import React from 'react';

export default function WheelMaintenHistoryTrailertailTable() {
  return <div>WheelMaintenHistoryTrailertailTable</div>;
}
